export const pad2 = (value) => String(value).padStart(2, '0');

export const dayKeyFromLocalDateObj = (date) => (
    `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`
);

export const parseDayKeyToLocalDate = (dayKey) => {
    if (!dayKey) return new Date();
    const [year, month, day] = dayKey.split('-').map(Number);
    return new Date(year, (month || 1) - 1, day || 1, 0, 0, 0, 0);
};

export const combineLocalDateAndTime = (dayKey, timeValue) => {
    const date = parseDayKeyToLocalDate(dayKey);
    const [hours, minutes] = (timeValue || '00:00').split(':').map(Number);
    date.setHours(hours || 0, minutes || 0, 0, 0);
    return date;
};

export const formatTimeLocal = (date) =>
    date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });

export const getTzOffsetMinutes = () => new Date().getTimezoneOffset();
